import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { mainnet, polygon, polygonAmoy, arbitrum, optimism, base, bsc } from 'viem/chains'

/**
 * WalletConnect / MetaMask mobile use this for session metadata and return-to-dapp hints.
 * In the browser the current origin is always the right value: it is exactly the address the user
 * opened (localhost in development, the hosted domain or the installed web app in production), and it
 * cannot be left pointing at a development URL by a build made on a developer machine.
 * VITE_APP_URL is only used where there is no window (tests, tooling).
 */
function resolveAppUrl() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  const fromEnv = import.meta.env.VITE_APP_URL
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/$/, '')
  }
  return ''
}

const chainId = parseInt(import.meta.env.VITE_CHAIN_ID || '80002', 10)
const activeChain = chainId === 137 ? polygon : polygonAmoy

const appUrl = resolveAppUrl()
const appIcon = appUrl ? `${appUrl}/m1nt-logo.png` : undefined

// All supported chains for payments (owner can pay on any network)
const supportedChains = [activeChain, mainnet, polygon, arbitrum, optimism, base, bsc].filter(
  (chain, index, self) =>
    // Remove duplicates
    self.findIndex((c) => c.id === chain.id) === index
)

export const config = getDefaultConfig({
  appName: 'M1NT Platform',
  appDescription: 'Professional card grading and NFT authentication on Polygon.',
  ...(appUrl ? { appUrl, ...(appIcon ? { appIcon } : {}) } : {}),
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'PLACEHOLDER_DEV',
  chains: supportedChains,
  ssr: false,
})
